
<template>
	 <!-- 面包屑导航 -->
	<div class="container">
    <div style="border-bottom: 4px solid #f4f4f4;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">能耗分析</el-breadcrumb-item>
        <el-breadcrumb-item>负荷曲线</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

		<el-row :gutter="12" >
			<el-col :span="5" class="silder-l" >
				<div class="m-left" :style="{ height:(tableHeight+100)+'px' }">
          <el-scrollbar style="height: 100%;">
            <el-form class="user-search" label-width="68px" >
             <!-- <el-form-item label="能源种类">
            	 <el-select size="small" v-model="dataParameter.energyType" placeholder="请选择" >
            		<el-option v-for="type in energyType" :label="type.value" :value="type.id" :key="type.value"></el-option>
            	  </el-select>
              </el-form-item> -->
              <el-form-item label="采集方案" v-if="user.name == 'admin'">
               <el-select size="small" v-model="dataSource" placeholder="请选择" @change="getJzData">
              	<el-option label="国网" value="1" ></el-option>
                <el-option label="南网" value="2" ></el-option>
               </el-select>
              </el-form-item>

            </el-form>
            <div>
            	<el-tree
            	:data="treeDaa"
            	:expand-on-click-node="false"
            	:highlight-current="true"
            	@node-click="handleNodeClick"
            	:props="jzProps"
            	v-loading="depLoading"
            	accordion
            	node-key='id'
            	>
            		<span class="custom-tree-node" slot-scope="{ node, data }">
            			<span>
            				<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building" style="color: #fc910d;"></i>
            				<i v-if="data.parentId" class="el-icon-location-outline"></i>
            				<i v-if="data.isJz" class="el-icon-coin" style="color: #2ec7c9;"></i>
            				{{ data.departmentName }}
            			</span>

            		</span>

            	</el-tree>
            </div>

          </el-scrollbar>

        </div>
			</el-col>

			<el-col :span="19"   >
				<div class="m-right">
					<!-- 计量点列表 -->
					<div class="data-list" >
						<el-form :inline="true"  class="user-search" @submit.native.prevent>
						  <el-form-item label="搜索：">
						    <el-input size="small" style="width: 200px;" @keyup.enter.native="getData"  placeholder="请输入计量点名称" v-model="dataParameter.meterPointName"></el-input>
						  </el-form-item>
              <el-form-item >
                <el-input size="small" style="width: 200px;" @keyup.enter.native="getData"  placeholder="请输入计量点地址" v-model="dataParameter.meterPoint"></el-input>
              </el-form-item>
              <el-form-item >
               <el-select size="small" v-model="dataParameter.energyType" placeholder="请选择" @change="getData" >
              	<el-option v-for="type in energyType" :label="type.value" :value="type.id" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
						  <el-form-item>
						    <el-button size="small" type="primary" icon="el-icon-search" @click="handelSearch">搜索</el-button>
						  </el-form-item>
						</el-form>

            <div class="dataBox clearfix" :style="{ height:tableHeight+'px' }">
              <div v-if="jlData.length == 0" style="line-height: 30px; color: #dddddd; text-align: center;font-size: 13px;">暂无数据</div>
              <el-scrollbar style="height: 100%;">

                <el-card class="box-card "  v-for="item in jlData" @click="Jledit(item)" :class="[ item.forwardActivePowerMeterCode == 0 ?'red':'', dataParameter.energyType == 16?'water':'' ] " >
                <div  class="c-header"  @click="Jledit(item)" style="cursor: pointer;">

                    <div v-if="dataParameter.energyType == 15" class="c-img" ><img class="db-icon" src="../../assets/img/db.png" /></div>
                    <div v-if="dataParameter.energyType == 16" class="c-img" ><img class="db-icon" src="../../assets/img/sb.png" /></div>
                    <p>{{item.meterPointName}}</p>


                </div>
                <div class="text">
                  <div v-if="dataParameter.energyType == 15">正向有功：<span style="font-weight: bold;">{{item.forwardActivePowerMeterCode}}</span></div>
                  <div v-if="dataParameter.energyType == 16" style="margin-bottom: 10px;" >水累计量：<span style="font-weight: bold;">{{item.waterCumulant}}</span></div>
                  <div class="clearfix cDetail" v-if="dataParameter.energyType == 15">
                    <div>尖:<span>{{item.tipActivePowerMeterCode}} </span> </div>
                    <div>峰:<span>{{item.peakActivePowerMeterCode}} </span> </div>
                    <div>平:<span>{{item.flatActivePowerMeterCode}} </span> </div>
                    <div>谷:<span>{{item.ebbActivePowerMeterCode}} </span> </div>

                  </div>
                </div>
                <div class="c-footer">
                  采集时间:{{item.latestCollectTime}}
                </div>
              </el-card>
              </el-scrollbar>
            </div>


						<!-- 分页组件 -->
						<Pagination v-bind:child-msg="pageparm"  v-if="showPage"  @callFather="callFather"></Pagination>
					</div>

				</div>

			</el-col>

		</el-row>


    <el-drawer :with-header="false" :visible.sync="deitJl" size="85%" :direction="direction">
      <!-- <div v-slot="title">计量点详情</div> -->
      <div class="j-title">
        <div style="font-weight: bold;">计量点详情</div>
        <div><el-button size="mini" @click="deitJl = false" round icon="el-icon-close">关闭</el-button></div>
      </div>
      <div style="padding: 20px; border-top: 1px solid #ebeef5;">



        <el-date-picker
          @change="getTime"
          size="small"

          :disabled="activeName == 'zonglang'"
          v-model="timeDatas"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-card style="margin: 10px 0;" shadow="hover">

          <el-descriptions :column="4">

              <template slot="title">
                <div class="j-img" v-if="dataParameter.energyType == 15"><img src="../../assets/img/db.png" /> {{meter.meterPointName}}</div>
                <div class="j-img" v-if="dataParameter.energyType == 16"><img src="../../assets/img/sb.png" /> {{meter.meterPointName}}</div>
              </template>
              <el-descriptions-item label="运行状态">
                <!-- <el-tag size="small"  type="success">运行中</el-tag> -->
              <el-tag size="small" v-if="meterDetail.isRunning" type="success">运行中</el-tag>
              <el-tag size="small" v-else type="info">已停止</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="用能单位">{{meter.energyUnit}}</el-descriptions-item>
               <el-descriptions-item label="采集周期">{{meter.collectCycle}}</el-descriptions-item>
              <el-descriptions-item label="计量表性质">{{meterDetail.meterProperties}}</el-descriptions-item>
              <el-descriptions-item label="计量表地址">{{meterDetail.meterPoint}}</el-descriptions-item>
               <el-descriptions-item label="终端地址">{{meterDetail.terminalCode}}</el-descriptions-item>
              <el-descriptions-item label="通讯规约">{{meterDetail.communicationProtocol}}</el-descriptions-item>
              <el-descriptions-item label="通讯方式">{{meterDetail.communicationType}}</el-descriptions-item>

              <el-descriptions-item label="计量方式">{{meterDetail.meterWay}}</el-descriptions-item>

              <el-descriptions-item label="倍率">{{meter.magnification}}</el-descriptions-item>
              <el-descriptions-item label="通信速率">{{meterDetail.communicationRate}}</el-descriptions-item>
              <el-descriptions-item label="容量">

              </el-descriptions-item>

          </el-descriptions>
        </el-card>

        <el-tabs style="margin-top: 10px;" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="总览" name="zonglang">
            <el-row :gutter="12">
              <!-- <el-col :lg="{span:'4-8'}" :md="8" :sm="12" :xs="24">
                <el-card shadow="hover">
                  <div class="zl-item">
                    <img src="../../assets/img/yl.png"/>
                    <div class="zl-label">本日{{dataParameter.energyType == 15 ? '电' : '水'}}量</div>
                    <div class="zl-value">
                      {{todayValue}}
                      <span v-if="dataParameter.energyType == 15">kWh</span>
                      <span v-if="dataParameter.energyType == 16">m³</span>
                    </div>
                  </div>
                </el-card>
              </el-col> -->
              <el-col  :span="6">
                <el-card shadow="hover">
                  <div class="zl-item">
                    <img src="../../assets/img/yl.png"/>
                    <div class="zl-label">

                      昨日{{dataParameter.energyType == 15 ? '电' : '水'}}量
                    </div>
                    <div class="zl-value">
                      {{yesTodayValue}}
                      <span v-if="dataParameter.energyType == 15">kWh</span>
                      <span v-if="dataParameter.energyType == 16">m³</span>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="6">
                <el-card shadow="hover">
                  <div class="zl-item">
                    <img src="../../assets/img/yl.png"/>
                    <div class="zl-label">

                      本月{{dataParameter.energyType == 15 ? '电' : '水'}}量
                    </div>
                    <div class="zl-value">
                      {{mothValue}}
                      <span v-if="dataParameter.energyType == 15">kWh</span>
                      <span v-if="dataParameter.energyType == 16">m³</span>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="6">
                <el-card shadow="hover">
                  <div class="zl-item">
                    <img src="../../assets/img/yl.png"/>
                    <div class="zl-label">

                      上月{{dataParameter.energyType == 15 ? '电' : '水'}}量
                    </div>
                    <div class="zl-value">
                      {{preMonthValue}}
                      <span v-if="dataParameter.energyType == 15">kWh</span>
                      <span v-if="dataParameter.energyType == 16">m³</span>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="6">
                <el-card shadow="hover">
                  <div class="zl-item">
                    <img src="../../assets/img/yl.png"/>
                    <div class="zl-label">

                      本年{{dataParameter.energyType == 15 ? '电' : '水'}}量
                    </div>
                    <div class="zl-value">
                      {{yearValue}}
                      <span v-if="dataParameter.energyType == 15">kWh</span>
                      <span v-if="dataParameter.energyType == 16">m³</span>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div class="zDetail" style="margin-top: 10px;" v-if="dataParameter.energyType == 15">
              <el-card shadow="hover">
                <el-row :gutter="10">
                  <el-col :lg="12" :xl="9" :md="12" :sm="13">
                    <div class="zDetail-list">
                      <div class="zDetail-item">
                        <div class="z-lable">瞬时量时间:</div>
                        <div style="margin-left: 8px; color: #9D9D9D;">{{meter.latestCollectTime}}</div>
                      </div>
                      <div class="zDetail-item">
                        <div class="z-lable">
                          电压:
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">A</div>
                          <div class="z-value-v">{{meter.APhaseVoltage}}V</div>
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">B</div>
                          <div class="z-value-v">{{meter.BPhaseVoltage}}V</div>
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">C</div>
                          <div class="z-value-v">{{meter.CPhaseVoltage}}V</div>
                        </div>
                      </div>
                      <div class="zDetail-item">
                        <div class="z-lable">
                          电流:
                        </div>
                        <div class="z-value">


                          <div class="z-value-t">A</div>
                          <!-- <div class="z-value-v">{{(meter.APhaseCurrent * parseInt(meter.magnification)).toFixed(4)}}A</div> -->
                          <div class="z-value-v">{{meter.APhaseCurrent}}A</div>
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">B</div>
                          <!-- <div class="z-value-v">{{(meter.BPhaseCurrent * parseInt(meter.magnification)).toFixed(4)}}A</div> -->
                          <div class="z-value-v">{{meter.BPhaseCurrent }}A</div>
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">C</div>
                          <!-- <div class="z-value-v">{{(meter.CPhaseCurrent * parseInt(meter.magnification)).toFixed(4)}}A</div> -->
                          <div class="z-value-v">{{meter.CPhaseCurrent }}A</div>
                        </div>
                      </div>
                      <div class="zDetail-item">
                        <div class="z-lable">
                          有功功率:
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">A</div>
                          <!-- <div class="z-value-v">{{(meter.APhaseActivePower* parseInt(meter.magnification)).toFixed(4)}}kW</div> -->
                          <div class="z-value-v">{{meter.APhaseActivePower}}kW</div>
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">B</div>
                          <!-- <div class="z-value-v">{{(meter.BPhaseActivePower* parseInt(meter.magnification)).toFixed(4)}}kW</div> -->
                          <div class="z-value-v">{{meter.BPhaseActivePower}}kW</div>
                        </div>
                        <div class="z-value">
                          <div class="z-value-t">C</div>
                          <!-- <div class="z-value-v">{{(meter.CPhaseActivePower* parseInt(meter.magnification)).toFixed(4)}}kW</div> -->
                          <div class="z-value-v">{{meter.CPhaseActivePower}}kW</div>
                        </div>
                      </div>
                    </div>
                  </el-col>

                  <el-col :lg="6" :xl="6" :md="6" :sm="4">
                    <div style="text-align: center;position: relative;margin-top: 26px;">
                      <el-progress type="dashboard" :width="140" :stroke-width="12" :percentage="percentage"  :format="format"></el-progress>
                      <div style="position: absolute;width: 100%;bottom: 10px;color: #C0C4CC;">功率因数</div>
                    </div>

                  </el-col>
                  <el-col :lg="6" :xl="9" :md="6" :sm="7">
                    <div class="zyou">
                      <div>总有功功率</div>
                      <!-- <div style="margin-top: 10px;">{{(meter.psum* parseInt(meter.magnification)).toFixed(4)}}kW</div> -->
                       <div style="margin-top: 10px;">{{meter.psum}}kW</div>
                    </div>
                  </el-col>
                </el-row>

              </el-card>
            </div>
            <div class="paybox" ref="zlang"></div>

          </el-tab-pane>
          <el-tab-pane label="电压" name="dianya" v-if="dataParameter.energyType == 15">
            <div class="paybox" ref="dianya"></div>
          </el-tab-pane>
          <el-tab-pane label="电流" name="dianliu" v-if="dataParameter.energyType == 15">
             <div class="paybox" ref="dianliu"></div>
          </el-tab-pane>
          <el-tab-pane label="功率" name="gonglv" v-if="dataParameter.energyType == 15">
             <div class="paybox" ref="gonglv" v-if="dataParameter.energyType == 15"></div>
          </el-tab-pane>
          <el-tab-pane label="功率因素" name="gonglvYs" v-if="dataParameter.energyType == 15">
             <div class="paybox" ref="gonglvYs"></div>
          </el-tab-pane>
          <el-tab-pane label="表码" name="biaoMa" v-if="dataParameter.energyType == 16">
            <div class="paybox" ref="biaoma"></div>
            </el-tab-pane>
        </el-tabs>



        <el-table v-if="activeName != 'zonglang'"  size="small" border  height="240" ref="table"   :data="listData" v-loading="loadReal"  :header-cell-style="this.$store.state.headerCss" >
      	<el-table-column type="index" label="序号" width="60px"></el-table-column>
      	<el-table-column label="数据时间" prop="latestCollectTime"></el-table-column>



       <!-- <el-table-column  label="A相电压(V)"  v-if="activeName =='dianya'">
          <template slot-scope="scope" >
            {{ scope.row.APhaseVoltage }}
          </template>
        </el-table-column>
        <el-table-column  label="B相电压(V)" v-if="activeName =='dianya'">
          <template slot-scope="scope" >
            {{ scope.row.BPhaseVoltage }}
          </template>
        </el-table-column>
        <el-table-column  label="C相电压(V)"  v-if="activeName =='dianya'">
          <template slot-scope="scope" >
            {{ scope.row.CPhaseVoltage }}
          </template>
        </el-table-column>

        <el-table-column  label="A相电流(A)" v-if="activeName =='dianliu'">
          <template slot-scope="scope" >

            {{ scope.row.APhaseCurrent  }}
          </template>
        </el-table-column>
        <el-table-column  label="B相电流(A)"  v-if="activeName =='dianliu'">
          <template slot-scope="scope" >

            {{ scope.row.BPhaseCurrent  }}
          </template>
        </el-table-column>
        <el-table-column  label="C相电流(A)"  v-if="activeName =='dianliu'">
          <template slot-scope="scope" >

            {{ scope.row.CPhaseCurrent  }}
          </template>
        </el-table-column>

        <el-table-column  label="A相有功功率" v-if="activeName =='gonglv'">
          <template slot-scope="scope" >

            {{ scope.row.APhaseActivePower  }}
          </template>
        </el-table-column>
        <el-table-column  label="B相有功功率"  v-if="activeName =='gonglv'">
          <template slot-scope="scope" >
            {{ scope.row.BPhaseActivePower  }}
          </template>
        </el-table-column>
        <el-table-column  label="C相有功功率"  v-if="activeName =='gonglv'">
          <template slot-scope="scope" >
            {{ scope.row.CPhaseActivePower  }}
          </template>
        </el-table-column>

        <el-table-column  label="功率因数"  v-if="activeName =='gonglvYs'">
          <template slot-scope="scope" >
            {{ scope.row.powerFactor  }}
          </template>
        </el-table-column> -->





        <el-table-column v-for="item in colData" :label="item.label" :prop="item.prop"></el-table-column>



      </el-table>


    	 </div>
    </el-drawer>
	</div>
</template>

<script>
	import PremsButton from "@/views/permission/PreButtom";
	import { provinceAndCityData,CodeToText } from 'element-china-area-data'
	import Pagination from '../../components/Pagination'
  import Chart from 'echarts'

	import {timestampToTime} from '@/utils/util'
	import {
	 findMeterInfoList,
   getMeterReadingData,
	 getDepartmentTerminalInfoLis,
	 getTerminalInfoByDepId,
   getOneMeterOverview,
   getOneMeterReadingData,
   getMeterInfoByTerCodeAndPointCode
	} from '../../api/energyMG'
  import {
  	getRealTimeData
  } from '../../api/dataMG'
	export default{
		data(){
			return{
        direction: 'rtl',
        terCode:'',
        percentage:0,
        psum:0,
        powerFactor:0,
        meterPoint:"",
        activeName:'zonglang',
        drawer:false,
        zdVisible:false,
        isCheck:false,
        loadDel:false,
        gVisible:false,
        isRun:false,
				canGetRoom:false,
        loadSwitch:false,
				options: provinceAndCityData,
				selectedOptions: [],
        mothValue:0,
        preMonthValue:0,
        todayValue:0,
        yearValue:0,
        yesTodayValue:0,
				suoshu:'',
        user:{},
				formInline:{
					type:""
				},
        meter:{

        },
        loadReal:false,
        downloadLoadin:false,

        mName:"",
        cId:"",



        ZlList:[],
        loadingZd:false,
        showZd:false,
        selectJl:[],
        dataSource:'2',
				upHeader:{
					'Content-Type': 'multipart/form-data'
				},
				depLoading:true,
				nyTitle:'新增用能单位',
				type:'电力',
				jieDianTitle:'新增节点',

				deitJl:false,
        tableHeight: 0,
				defaultProps:{
					children: 'option',
					label: 'type'
				},
        loadingExport:false,


        sRules:{
          passWord:[
            {required:true,message:'请输入密码',trigger: 'blur'}
          ]
        },

				//查询参数
				dataParameter:{
					terIds:JSON.stringify([]),
					currentPage: 1,
					pageSize: 30,
					meterPoint:'',
					meterPointName:'',
					energyType:15,

				},
        switchVisible:false,

        loadSave:false,
				dataItemList:[

				],
				showDataItemInfo:"",


				energyType:[
          {id:15,value:"电力"},
          {id:16,value:"水"}
        ],
				roomList:[],
        commAddress:"",
				communicationProtocolList:[],//规约类型集合
				communicationTypeList:[], //通讯方式
				loading:true,

				 // 分页参数
				pageparm: {
				  currentPage: 1,
				  pageSize: 30,
				  total: 0
				},
        showPage:true,

				terIds:{},
				currtypeId:0,
				meterInfo:{},
				tetInfo:[],//集中器数据

				treeDaa: [],
				loadLoadin:false,
				defaultItems:[],
				jzProps:{
					label: function( data,node ){
						console.log(data)
					},
					children: 'deps',

				},
        colData:[],
        listData:[],
				jltitle:'',
				jlData:[],
        timeDatas:[],
        startTime:"",
        endTime:"",
        meterDetail:{

        }
			}
		},

    mounted(){

    },
		created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

			this.choiseOpeion = ''
			this.getJzData();
      this.$nextTick(() => {

      	this.tableHeight = window.innerHeight - 260


        console.log(window.innerHeight- 260)
      })

		//	this.getTerInfo();

			//this.$store.dispatch('getDepts')

		},
		 // 注册组件
		components: {
		  Pagination,
		  PremsButton
		},

		computed:{

		},


		methods:{

      handleClick(){
        this.setCharts()

      },

      format(percentage){
        return this.powerFactor+''
      },

      Jledit(row){

        this.deitJl = true
        this.activeName = 'zonglang'
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let strDate = date.getDate();
        this.timeDatas = [date,date.getTime()+24*60*60*1000]
        this.startTime =  timestampToTime(date).substring(0,10)
        this.endTime = timestampToTime(date.getTime()+24*60*60*1000).substring(0,10)
        this.meter = row
        this.mName = row.meterPointName
        this.cId = row.id
        this.powerFactor = row.powerFactor




        setTimeout(() => {
          this.percentage = this.powerFactor * 100
        },800)





        this.terCode =  this.dataParameter.energyType == 15 ? row.terminalCode : row.terminalMeterPoint.split('-')[0]
        this.meterPoint = row.meterPoint

        this.$nextTick(() => {
          this.getZongLan()
          this.getChartData()
          this.getDbDetail()
        })


      },



      getZongLan(){
        let param = {
           energyType:this.dataParameter.energyType,
           terCode:this.terCode,
           meterPoint:this.meterPoint,
        }
        getOneMeterOverview(param).then(res => {
          if(res.status == 1 ){
            this.ZlList = res.data.list30
            this.mothValue = res.data.mothValue
            this.preMonthValue = res.data.preMonthValue
            this.todayValue = res.data.todayValue
            this.yearValue = res.data.yearValue
            this.yesTodayValue = res.data.yesTodayValue
            let option = {
              tooltip: {
                trigger: 'axis'
              },
              title:[
                {
                  text:'近30日用量',
                  left:'center',
                  top:'10',
                  textStyle:{
                    fontSize:14
                  }
                }
              ],

              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                show: true,
                feature: {
                  mark: {
                    show: true
                  },
                  dataView: {
                    show: true,
                    readOnly: false
                  },
                  magicType: {
                    show: true,
                    type: ['line', 'bar'],
                  },
                  restore: {
                    show: true
                  },
                  saveAsImage: {
                    show: true
                  }
                }
              },
              calculable: true,
              xAxis: [{
                type: 'category',
                data: this.ZlList.map(item => item.recordDate.substring(5,10))
              }],
              yAxis: [{
                type: 'value',
              }],
              series: [{
                name: '用量',
                type: 'bar',
                data: this.ZlList.map(item => item.totalValue),
              }]
             }


            this.$nextTick(() => {
              this.chart = Chart.init(this.$refs.zlang,'macarons')
              this.chart.setOption(option,true)
            })
          }
        })
      },

      getDbDetail(){
        let param = {
           terminalCode:this.terCode,
           meterPoint:this.meterPoint,
        }

        getMeterInfoByTerCodeAndPointCode(param).then(res => {
          if(res.status == 1){
            this.meterDetail = res.data
          }
        })
      },

      getChartData(init){
        let parm = {
          energyType:this.dataParameter.energyType,
          terCode:this.terCode,
          meterPoint:this.meterPoint,
          startTime:this.startTime,
          endTime:this.endTime,
        }

        getOneMeterReadingData(parm).then(res => {
        	this.loading = false

        	if(res.status == 1){
        		this.listData = res.data.result
            if(init){
              this.setCharts()
            }


        	}else{
        		this.listData = []
        	}
        })
      },

      setCharts(){
        let xArr = this.listData.map(item => item.latestCollectTime)
        let chartElemnt = null
        let lName= []
        let sData = []
        let sArr = []
        if(this.activeName == 'dianya'){
         lName = ['A相电压(V)','B相电压(V)','C相电压(V)']
         this.colData = [
           {
             label:'A相电压(V)',
             prop:'APhaseVoltage'
           },
           {
             label:'B相电压(V)',
             prop:'BPhaseVoltage'
           },
           {
             label:'C相电压(V)',
             prop:'CPhaseVoltage'
           },
         ]
         this.$nextTick(() => {chartElemnt =  this.$refs.dianya;})

          sArr = [
            {
              name: 'A相电压(V)',
              type: 'line',
              data: this.listData.map(item => item.APhaseVoltage),
            },
            {
              name:  'B相电压(V)',
              type: 'line',
              data: this.listData.map(item => item.BPhaseVoltage),
            },
            {
              name:  'C相电压(V)',
              type: 'line',
              data: this.listData.map(item => item.CPhaseVoltage),
            }
          ]
        }else if(this.activeName == 'dianliu'){
          this.$nextTick(() => { chartElemnt =  this.$refs.dianliu})
          this.colData = [
            {
              label:'A相电流(A)',
              prop:'APhaseCurrent'
            },
            {
              label:'B相电流(A)',
              prop:'BPhaseCurrent'
            },
            {
              label:'C相电流(A)',
              prop:'CPhaseCurrent'
            },
          ]
          lName = ['A相电流(A)','B相电流(B)','C相电流(C)']
          sArr = [
            {
              name: 'A相电流(A)',
              type: 'line',
              // data: this.listData.map(item => (item.APhaseCurrent * parseInt(item.magnification)).toFixed(4)),
              data: this.listData.map(item => item.APhaseCurrent),
            },
            {
              name:  'B相电流(B)',
              type: 'line',
              // data: this.listData.map(item => (item.BPhaseCurrent * parseInt(item.magnification)).toFixed(4)),
             data: this.listData.map(item => item.BPhaseCurrent),
            },
            {
              name:  'C相电流(C)',
              type: 'line',
              // data: this.listData.map(item => (item.CPhaseCurrent * parseInt(item.magnification)).toFixed(4)),
             data: this.listData.map(item => item.CPhaseCurrent),
            }
          ]
        }else if(this.activeName == 'gonglv'){
          lName = ['A相有功功率','B相有功功率','C相有功功率']
          this.colData = [
            {
              label:'A相有功功率',
              prop:'APhaseActivePower'
            },
            {
              label:'B相有功功率',
              prop:'BPhaseActivePower'
            },
            {
              label:'C相有功功率',
              prop:'CPhaseActivePower'
            },
          ]
          this.$nextTick(() => { chartElemnt =  this.$refs.gonglv})
          sArr = [
            {
              name: 'A相有功功率',
              type: 'line',
              data: this.listData.map(item => item.APhaseActivePower)
              // data: this.listData.map(item => (item.APhaseActivePower * parseInt(item.magnification)).toFixed(4)),
            },
            {
              name:  'B相有功功率',
              type: 'line',
              data: this.listData.map(item => item.BPhaseActivePower)
              // data: this.listData.map(item => (item.BPhaseActivePower * parseInt(item.magnification)).toFixed(4)),
            },
            {
              name:  'C相有功功率',
              type: 'line',
              data: this.listData.map(item => item.CPhaseActivePower)
              // data: this.listData.map(item => (item.CPhaseActivePower * parseInt(item.magnification)).toFixed(4)),
            }
          ]
        }else if(this.activeName == 'gonglvYs'){
          lName = ['功率因数']
          this.colData = [
            {
              label:'功率因数',
              prop:'powerFactor'
            },

          ]
          this.$nextTick(() => { chartElemnt =  this.$refs.gonglvYs})
          sArr = [
            {
              name: '功率因数',
              type: 'line',
              data: this.listData.map(item => item.powerFactor),
            },

          ]
        }else if(this.activeName == 'biaoMa'){
           lName = ['水累计量']
           this.colData = [
             {
               label:'水累计量',
               prop:'waterCumulant'
             },

           ]
           this.$nextTick(() => { chartElemnt =  this.$refs.biaoma})
           sArr = [
             {
               name: '水累计量',
               type: 'line',
               data: this.listData.map(item => item.waterCumulant),
             },
           ]
        }
        let option = {
         tooltip: {
           trigger: 'axis'
         },
         legend: {
           data: lName,
         },
         grid: {
           left: '3%',
           right: '4%',
           bottom: '3%',
           containLabel: true
         },
         toolbox: {
           show: true,
           feature: {
             mark: {
               show: true
             },
             dataView: {
               show: true,
               readOnly: false
             },
             magicType: {
               show: true,
               type: ['line', 'bar'],
             },
             restore: {
               show: true
             },
             saveAsImage: {
               show: true
             }
           }
         },
         calculable: true,
         xAxis: [{
           type: 'category',
           data: xArr
         }],
         yAxis: [{
           type: 'value',
         }],
         series: sArr
        }

       this.$nextTick(() => {
         this.chart = Chart.init(chartElemnt,'macarons')
         this.chart.setOption(option,true)
          this.$refs.table.doLayout();
       })



      },




      getTime(e){

      	this.startTime = timestampToTime(this.timeDatas[0]).substring(0,10)
      	this.endTime = timestampToTime(this.timeDatas[1]).substring(0,10)

        this.getChartData(true)

      },


      setYiChang({row,rowIndex}){
        console.log(row.meterPointStatus)
        if(row.meterPointStatus == 2){
          return 'warning-row'
        }

      },

      getSelectJl(data){
        this.selectJl = data
      },






      handelSearch(){
        this.dataParameter.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(()=>{
          this.showPage = true
        })


      },


      checkSwitch(){
        this.$refs['geditForm'].validate( val =>{
          CheckSwitchAdmin(this.checkForm).then(res => {
            if(res.status == 1){
              this.switchVisible = true
              this.gVisible = false
              this.isCheck = true

            }else{
              this.$message.error(res.msg)
            }
          })
        })
      },








			getDataItemList:function(eType){

				getAllDataItemList({energyType:eType}).then(res =>{
					if(res.status == 1){
						this.dataItemList = res.data.treeList
						this.defaultItems = res.data.ids
						this.showDataItemInfo = '共'+ res.data.ids.length+'项数据，点击查看'

						this.jlEditParmater.dataItem = this.defaultItems.join('-')
					}
				})
			},

			handleCheckChange:function(data,checked){
				let arr = this.$refs.popupTree.getCheckedKeys()
				this.jlEditParmater.dataItem = arr.join('-')
				this.showDataItemInfo = '共'+ arr.length+'项数据，点击查看'
			},
			handleNodeClick(data){
        this.dataParameter.currentPage = 1
        this.showPage = false
        console.log(data)
				if(data.isJz){
					let idstr = JSON.stringify([{id:data.id}])
					this.dataParameter.terIds = idstr
          this.showZd = true
          this.commAddress = data.terminalCode
					this.getData();

				}else{
          this.showZd = false
					//点击部门获得集中器id
					getTerminalInfoByDepId({depId:data.id}).then(res => {
						if(res.status == 1){
							let arr = []
							res.data.forEach( item => {
								let obj = {}
								obj.id = item
								arr.push(obj)
							})

							if(arr.length){
								this.dataParameter.terIds = JSON.stringify(arr)
							}else{
								//解决bug 如果获得的集中器是个空数组 查询数据将会是所有的数据 ，所以这个时候 给个不存在 的id
								this.dataParameter.terIds = JSON.stringify([{id:0}])
							}
							this.getData();
						}else{
							this.$message.error(res.msg)
						}
					})
				}
        this.$nextTick(()=>{
          this.showPage = true
        })

			},





      editEnergyChange(data){
				this.getDataItemList(data)
			},


			append(data){
				this.editFormVisible = true
			},
			//获取数据
			getJzData(){
				this.depLoading = true;
        let param = {
          dataSource:this.dataSource
        }
				getDepartmentTerminalInfoLis(param).then(res => {
					if(res.status == 1){
						//数据改造
						this.treeDaa = this.chagenData(res.data.menuDepList)
						this.depLoading = false;
						return res.data.terIds
					}else{
						this.$message.error(res.data.msg)
					}
				}).then( res => {
					let arr = []
					res.forEach( item => {
						arr.push({ id: item})
					})
					this.dataParameter.terIds = JSON.stringify(arr)
					this.getData();
				})
			},


			chagenData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.chagenData(item.deps)
					}
				})

				return  data
			},
			handleChange(e){
				let param = {
					province : CodeToText[e[0]],
					city     : CodeToText[e[1]]
				}
				this.getroom(param)
			},

			getroom(param){
				getRoomList(param).then( res =>{
					if(res.status == 1){
						this.canGetRoom = true

						this.roomList = res.data
					}
				})
			},
			getData(){
				this.loading = true

				getRealTimeData(this.dataParameter).then(res => {

					if(res.status == 1){
						this.loading = false
						this.jlData = res.data.result



						this.pageparm.total = res.data.totalCount
					}else{
						this.loading = false
						this.$message.error(res.msg)
					}
				})
				.catch( err =>{
					this.loading = false
					this.$message.error(err)
				})
			},
			// 分页插件事件
			callFather(parm) {

			  this.dataParameter.currentPage = parm.currentPage
			  this.dataParameter.pageSize = parm.pageSize
			  this.getData()
			},


		}

	}
</script>

<style scoped>
  .j-title{
    line-height: 50px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
  }
  .zyou{
    text-align: center;
    padding-top: 60px;
    color: #606266;

    font-size: 18px;
  }
  .el-card__header{
    padding: 10px 20px !important;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .el-card__body{

  }
  .c-header{
    display: flex;
    font-weight: bold;
    position: relative;
    top: -10px;
  }
  .c-img{
    justify-content: center;align-items: center;display: flex;
    margin-right: 8px;
  }
  .c-header img{
    display: block;

  }
  .c-header p{
    flex: 1;
  }
  .db-icon{
    width: 24px;


  }
  .j-img img{
    width: 30px;
    margin-right: 10px;
    position: relative;
    top: 6px;
  }
  .el-drawer__header{
    border-bottom: 1px solid #CCCCCC;
  }
  .zDetail-item,.z-value{
    font-size: 16px;
    line-height: 36px;
    display: flex;
  }
  .zDetail-box{
    display: flex;
  }
  .zDetail-item{
    margin-bottom: 10px;
  }
  .z-value{
    border-bottom: 1px solid #CCCCCC;
    margin: 0 10px;
    position: relative;
    top: -4px;
  }
  .zlang-list{
    display: flex;
  }
  .zl-item{
    display: flex;
    justify-content: space-between;
    position: relative;
  }
  .zl-label{
    padding-left: 28px;
  }
  .zl-item img{
    width: 22px;
    position: absolute;
    top: 2px;
  }
  .z-lable{
    width: 100px;
    font-weight: bold;
  }
  .z-value{
    width: 120px;
    font-size: 14px;
  }
  .z-value-t{
    padding-right: 20px;
  }
  .zl-value{
     position: relative;
     top:3px
  }
  .zl-value span{
    padding-left: 4px;
    font-size: 12px;
    color: #ccc;


  }
  .yi-chang{
     color: #F56C6C;
  }
  .warning-row{
    color: #F56C6C;
  }

	.container{
		height: 100%;

	}
  .dataBox{
    overflow-y: auto;
  }
  .box-card{
    width: 240px;
    height: 200px;
    float: left;
    margin: 4px;
    font-size: 13px;
  }
  .box-card.water{
    height: 120px;
  }
  .box-card.red{
    background: #fde2e2;
  }
  .box-card:hover{
    background: #fafafa;
  }
  .cDetail{

  }
  .cDetail div{
    float: left;
    width: 50%;

    line-height: 30px;
  }
  .cDetail div span{
    font-weight: bold;
  }
	.nybox{

		margin-top: 10px;
		padding:0 20px;
	}

	.demo-table-expand .el-form-item__content {
		line-height: 30px;
		font-size: 13px;
	}
	.demo-table-expand .el-form-item__label{
		font-size: 13px;
		line-height: 30px;
	}
	.cp .el-input__inner{
		cursor: pointer;
	}

	.el-table__expanded-cell[class*=cell]{
		padding: 10px 30px;
	}

	.m-left,.m-right{
		background: #fff;
		padding: 20px;
	overflow-y: auto;


	}
	.m-right{

		padding:0 20px;

	}

	.el-tree-node__content{
		line-height: 40px;
	}

	.el-tree-node{
		margin: 10px 0;
	}
	.data-list{
		padding-top: 20px;

	}

	.silder-l{
		height: 100%;
		border-right: 4px solid #f4f4f4;
	}
	.m-left .el-tree{
		font-size: 13px;
	}
	.m-left .el-tree i{
		font-size: 14px;
	}
	.m-left /deep/ .el-tree-node{
		white-space: normal !important;
	}
	.m-left /deep/ .el-tree-node__content{
		height: auto;
		padding: 6px 0;
	}
  .paybox {
  	width: 100%;
  	background-color: #fff;
  	box-sizing: border-box;
  	border-radius: 5px;

  	height: 26vh;
  }

	.el-tree{
		border-radius: 6px;

	}
	.t-title{
		color: #ccc;
		font-size: 12px;
		padding-left: 10px;
	}
	.el-textarea__inner{
		height: 80px;

	}
	.el-textarea.is-disabled .el-textarea__inner{
		color: #666;
	}
	.data-list{
		height: 100%;
	}
	.demo-table-expand .el-form-item{
		margin-bottom: 0px;
	}

	.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #8fc6ff;
		color: #fff;
	}
	.el-form-item {
		margin-bottom: 15px;
	}
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  @media only screen and (max-width: 1300px) {
    .z-lable{
      font-size: 14px;
    }
    .z-value{
      font-size: 13px;
      width: 100px;
    }
    .zyou{
      font-size: 16px;
    }

  }
  @media only screen and (max-width: 1200px) {

    .zl-item{
      font-size: 12px;
    }



  }
  @media only screen and (max-width: 1000px) {
    .z-lable{
      font-size: 13px;
    }
    .z-value{
      font-size: 12px;
      width: 100px;
    }
    .zyou{
      font-size: 14px;
    }



  }


    @media only screen and (min-width: 768px) {
      .el-col-sm-4-8 {
        width: 20%;
      }
      .el-col-sm-offset-4-8 {
        margin-left: 20%;
      }
      .el-col-sm-pull-4-8 {
        position: relative;
        right: 20%;
      }
      .el-col-sm-push-4-8 {
        position: relative;
        left: 20%;
      }
    }

    @media only screen and (min-width: 992px) {
      .el-col-md-4-8 {
        width: 20%;
      }
      .el-col-md-offset-4-8 {
        margin-left: 20%;
      }
      .el-col-md-pull-4-8 {
        position: relative;
        right: 20%;
      }
      .el-col-md-push-4-8 {
        position: relative;
        left: 20%;
      }
    }

    @media only screen and (min-width: 1200px) {
      .el-col-lg-4-8 {
        width: 20%;
      }
      .el-col-lg-offset-4-8 {
        margin-left: 20%;
      }
      .el-col-lg-pull-4-8 {
        position: relative;
        right: 20%;
      }
      .el-col-lg-push-4-8 {
        position: relative;
        left: 20%;
      }
    }

    @media only screen and (min-width: 1920px) {
      .el-col-xl-4-8 {
        width: 20%;
      }
      .el-col-xl-offset-4-8 {
        margin-left: 20%;
      }
      .el-col-xl-pull-4-8 {
        position: relative;
        right: 20%;
      }
      .el-col-xl-push-4-8 {
        position: relative;
        left: 20%;
      }
    }

</style>



// WEBPACK FOOTER //
// src/views/analysis/fuHe.vue